"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20SeedPickerScene = void 0;
const Game_1 = require("./Game");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHListMenuV3_1 = require("./KH/Menu/V3/KHListMenuV3");
const KHListControllerV3_1 = require("./KH/Menu/V3/KHListControllerV3");
const KHMenuSpecV3_1 = require("./KH/Menu/V3/KHMenuSpecV3");
const KHMenuEntryV3_1 = require("./KH/Menu/V3/KHMenuEntryV3");
const KHMenuNavigatorV3_1 = require("./KH/Menu/V3/KHMenuNavigatorV3");
const Z20AudioScene_1 = require("./Z20AudioScene");
const IGO50Terminal_1 = require("./IGO50Terminal");
const IGO50PausableScene_1 = require("./IGO50PausableScene");
const Z20SceneNames_1 = require("./Z20SceneNames");
const KHMenuEntrySelectV3_1 = require("./KH/Menu/V3/KHMenuEntrySelectV3");
const Z20TerminalSetup_1 = require("./Z20TerminalSetup");
class Z20SeedPickerScene extends IGO50PausableScene_1.default {
    constructor() {
        super(Z20SceneNames_1.default.SeedPicker);
    }
    init(data) {
        this.config = (data === null || data === void 0 ? void 0 : data.config) || Z20TerminalSetup_1.Z20TerminalSetup.StandardSetup;
    }
    create() {
        IGO50Terminal_1.default.CurrentCode = undefined;
        // this.audio_scene.play('bg_audio', true, true, 0.5)
        this.controller = Game_1.gameManager.getController();
        this.controller.register(KHInputScene_1.KHInputScene.SharedInput);
        // this.createTerminalMenu();
        this.createMenu();
    }
    loadLevel() {
        console.log('load');
        let seed = 0;
        for (let entry of this.entries) {
            seed *= 10;
            seed += entry.getSelected().value;
        }
        this.scene.start(Z20SceneNames_1.default.RuleDisplay, { seed, config: this.config });
    }
    createMenu() {
        const sx = Game_1.game.width / 2 - 2.5 * 16;
        const width = 160;
        const height = 96;
        const yOff = 8;
        const entries = [];
        for (let i = 0; i < 6; i++) {
            entries.push(this.addNumberOption(sx + 16 * i));
        }
        const menuSpec = new KHMenuSpecV3_1.KHMenuSpecV3({
            menuNavigator: new KHMenuNavigatorV3_1.KHMenuNavigatorV31D(KHMenuNavigatorV3_1.NavigationDirection.Horizontal),
            menuEntries: entries,
            confirmCallback: () => {
                Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move_bad');
                this.loadLevel();
            }
        });
        this.entries = entries;
        const sy = Game_1.game.height / 2;
        new KHListMenuV3_1.KHListMenuV3({
            scene: this,
            registrar: KHInputScene_1.KHInputScene.SharedInput,
            controller: KHListControllerV3_1.KHListControllerV3.default(),
            menuSpec,
            rect: new Phaser.Geom.Rectangle(0, 0, 80, 80),
            optionCreationCallback: (createObject) => {
                let typedObject = createObject.menuOption;
                // const text = this.add.bitmapText(typedObject.extras.x, game.height/2, 'legacys', String(typedObject.getSelected().value)).setOrigin(0.5, 0.5);
                const numberImage = this.add.sprite(typedObject.extras.x, Game_1.game.height / 2, `npc${typedObject.getSelected().value + 1}`).setOrigin(0.5, 0.5);
                const arrowUp = this.add.sprite(typedObject.extras.x, Game_1.game.height / 2 - 16, 'arrow_up').setOrigin(0.5, 0.5);
                const arrowDown = this.add.sprite(typedObject.extras.x, Game_1.game.height / 2 + 16, 'arrow_up').setOrigin(0.5, 0.5).setFlipY(true);
                function imgName() {
                    return `npc${typedObject.getSelected().value + 1}`;
                }
                function animName() {
                    return `npc${typedObject.getSelected().value + 1}-idle`;
                }
                typedObject.registerCallback('updatedSelectedOption', (ev) => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('tick');
                    // text.text = String(ev.selection.value);
                    numberImage.setTexture(`npc${typedObject.getSelected().value + 1}`);
                    numberImage.play({ key: animName(), repeat: -1 });
                });
                function setSelected(selected) {
                    // text.setTint(selected ? Z20SeedPickerScene.HIGHLIGHT_COLOR : 0xFFFFFF);
                    if (selected) {
                        numberImage.play({ key: animName(), repeat: -1 });
                    }
                    else {
                        numberImage.stop();
                        numberImage.setFrame(0);
                    }
                    arrowUp.setTint(selected ? Z20SeedPickerScene.HIGHLIGHT_COLOR : 0xFFFFFF);
                    arrowDown.setTint(selected ? Z20SeedPickerScene.HIGHLIGHT_COLOR : 0xFFFFFF);
                }
                setSelected(createObject.menuOption.getIsSelected());
                createObject.menuOption.registerCallback("is_selected_updated", (data) => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('tick');
                    setSelected(data.selected);
                });
                // const bounds = text.getTextBounds(true).global;
                const bounds = numberImage.getBounds();
                return { go: numberImage, bounds: new Phaser.Geom.Rectangle(bounds.x, bounds.y, bounds.width, bounds.height) };
            }
        });
    }
    addText(optionText) {
        return KHMenuEntryV3_1.KHMenuEntryV3.JustText(optionText);
    }
    addNumberOption(x) {
        let options = [];
        for (let i = 0; i < 10; i++) {
            options.push({
                name: `npc${i}`,
                value: i
            });
        }
        return new KHMenuEntrySelectV3_1.KHMenuEntrySelectV3({
            selectable: true,
            selectDirection: KHMenuEntrySelectV3_1.SelectDirection.Vertical,
            extras: { x },
            options
        });
    }
    addClickableOption(optionText, callback, isDefault = false) {
        return new KHMenuEntryV3_1.KHMenuEntryV3({
            text: optionText,
            selectable: true,
            confirmCallback: callback,
            isDefaultSelection: isDefault,
        });
    }
}
exports.Z20SeedPickerScene = Z20SeedPickerScene;
Z20SeedPickerScene.HIGHLIGHT_COLOR = 0xe8ea4a;
